import { NgModule } from '@angular/core';

import { SharedModule } from 'ish-shared/shared.module';

import { DotCmsComponentsModule } from './dot-cms-components/dot-cms-components.module';
import { DotCmsDirectivesModule } from './dot-cms-directives/dot-cms-directives.module';
import { DotCmsPipesModule } from './pipes/dot-cms-pipes.module';
import { DotCmsDefaultPageComponent } from './shared/dot-cms-default-page/dot-cms-default-page.component';
import { DotCmsFooterComponent } from './shared/dot-cms-footer/dot-cms-footer.component';
import { DotCmsDesktopViewHeaderNavigationComponent } from './shared/dot-cms-header-navigation/dot-cms-desktop-view-header-navigation/dot-cms-desktop-view-header-navigation.component';
import { DotCmsGeneralViewHeaderNavigationComponent } from './shared/dot-cms-header-navigation/dot-cms-general-view-header-navigation/dot-cms-general-view-header-navigation.component';
import { DotCmsHeaderFolderIndexPageCheckComponent } from './shared/dot-cms-header-navigation/dot-cms-header-folder-index-page-check/dot-cms-header-folder-index-page-check.component';
import { DotCmsHeaderNavigationComponent } from './shared/dot-cms-header-navigation/dot-cms-header-navigation.component';
import { DotCmsSubFolderHeaderNavigationComponent } from './shared/dot-cms-header-navigation/dot-cms-sub-folder-header-navigation/dot-cms-sub-folder-header-navigation.component';
import { DotCmsPageContentComponent } from './shared/dot-cms-page-content/dot-cms-page-content.component';

@NgModule({
  imports: [DotCmsComponentsModule, DotCmsDirectivesModule, DotCmsPipesModule, SharedModule],
  declarations: [
    DotCmsDefaultPageComponent,
    DotCmsDesktopViewHeaderNavigationComponent,
    DotCmsFooterComponent,
    DotCmsGeneralViewHeaderNavigationComponent,
    DotCmsHeaderFolderIndexPageCheckComponent,
    DotCmsHeaderNavigationComponent,
    DotCmsPageContentComponent,
    DotCmsSubFolderHeaderNavigationComponent,
  ],
  exports: [SharedModule],
  providers: [],
})
export class DotCmsModule {}
